import { IAppState } from "../../../app/appTypes"
import { ICaseSource } from "../../../features/sources/state/caseSourceTypes"


export const getAllCaseSources = (state: IAppState): { [id: string]: ICaseSource } => state.entities.caseSources.byId

export const getAllCaseSourceIds = (state: IAppState): string[] => state.entities.caseSources.allIds

export const getCaseSourceById = (state: IAppState, id: string): ICaseSource =>  state.entities.caseSources.byId[id]
